module.exports = __webpack_public_path__ + "img/assessment-waiting.3b394614.svg";